<template>
  <main class="pp-page--confirmation">
    <h1 class="title title--desktop" v-t="'message.confirmation_screen'"></h1>
    <p v-if="user.userDetails" class="confirmation__order-confirmation">{{ $t('payment.order_confirmation', { email: user.userDetails.personEmail }) }}</p>
    <div v-if="error" class="pp-layout-container">
      <error v-if="error">{{ $t("errors.cart_confirmation") }}</error>
    </div>
    <div v-else class="pp-layout-container">
      <div class="pp-preamble">
        <h1 class="title title--mobile" v-t="'message.confirmation_screen'"/>
        <p v-if="user.userDetails" class="confirmation__order-confirmation">{{ $t('payment.order_confirmation', { email: user.userDetails.personEmail }) }}</p>
      </div>
      <section class="pp-main-content">
        <shopping-cart-product
          v-for="item in cart.aggregatedCart"
          :key="cart.aggregatedCart[item]"
          :productContents="item"
        />
      </section>
      <aside class="pp-sidebar">
        <p>
          {{ $t("message.booking_reference") }}: {{ getTransactionReference }}
        </p>
        <p v-for="(ticket, index) in getETicketUrl" :key="`eticket-${index}`">
          {{ $t("message.download_eticket") }}
          <a :href="ticket" target="_blank">
            <font-awesome-icon icon="download" />
          </a>
        </p>
        <p>{{ $t("message.booking_date") }}: {{ localisedDate() }}</p>
        <p v-if="getPaymentMethod">{{ $t("message.payment_method") }}: {{ getPaymentMethod }}</p>
        <!-- desktop actions in the sidebar -->
        <cart-total/>
        <a :href="getWhatsOnUrl" class="btn btn--secondary btn--whats-on">{{ $t("payment.continue_shopping") }}</a>
      </aside>
      <!-- The mobile actions -->
      <div class="pp-actions">
        <div class="pp-actions__container">
          <p>
            {{ $t("message.booking_reference") }} {{ getTransactionReference }}
          </p>
          <p v-for="(ticket, index) in getETicketUrl" :key="`eticket-${index}`">
            {{ $t("message.download_eticket") }}
            <a :href="ticket" target="_blank">
              <font-awesome-icon icon="download" />
            </a>
          </p>
          <p>{{ $t("message.booking_date") }}: {{ localisedDate() }}</p>
          <p v-if="getPaymentMethod">{{ $t("message.payment_method") }}: {{ getPaymentMethod }}</p>
          <cart-total/>
          <a :href="getWhatsOnUrl" class="btn btn--secondary btn--whats-on">{{ $t("payment.continue_shopping") }}</a>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import ShoppingCartProduct from "@/components/shopping-cart/ShoppingCartProduct";
import CartTotal from "@/components/shopping-cart/CartTotal";
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment-timezone";

export default {
  name: "cart-confirmation",
  components: {
    ShoppingCartProduct,
    CartTotal,
  },
  data() {
    return {
      error: null,
    };
  },
  watch: {
    "$i18n.locale": function() {
      this.initMounted();
    }
  },
  async mounted() {
    await this.initMounted();
  },
  computed: {
    ...mapState(["cart", "user"]),
    ...mapGetters([
      "getETicketUrl",
      "getTransactionReference",
      "getTransactionDate",
      "getPaymentMethod",
      "getWhatsOnUrl"
    ]),
  },
  methods: {
    async initMounted() {
      // First: Clear old cart just in case anything strange happened between cart & payment screens (e.g. user does something in another browser / window)
      // Second: Retrieve items based off the cart ID which should still exist
      this.clearError();

      // Save cartGuid in case we don't have it in the URL
      let transactionCartId = this.cart.cartGuid;

      // If we have a cartGuid in the URL, use it for retrieving cartItems
      if (this.$route.query.cart != undefined) {
        transactionCartId = this.$route.query.cart;
        this.updateCartGuid(transactionCartId);
      }

      let transactionId = this.$route.query.transaction;
      let externalTransactionId = this.$route.query.externalTransactionId;

      await this.getCartItems("cart-confirmation");
      await this.getTransaction(externalTransactionId);

      this.destroyCartInstance("cart-confirmation");
    },
    localisedDate() {
      let momentLocale = "en";

      switch (this.$i18n.locale) {
        case "tc":
          momentLocale = "zh-HK";
        case "sc":
          momentLocale = "zh-CN";
      }

      moment.locale(momentLocale);
      // Times are given to us in local with Hong Kong timezone attached. We always want
      // to display times in local Hong Kong time. If we don't specify it will convert to
      // the users local browser time.
      if (momentLocale == "en") {
        return moment(this.getTransactionDate).tz("Asia/Hong_Kong").format(
          "ddd, DD MMMM YYYY h:mma"
        );
      } else {
        return moment(this.getTransactionDate).tz("Asia/Hong_Kong").format(
          "dddd, LL, a h:mm"
        );
      }
    },
    ...mapActions([
      "destroyCartInstance",
      "getCartItems",
      "updateCartGuid",
      "getTransaction",
      "clearError",
    ]),
  },
};
</script>